'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormRest = function () {
  function FormRest($http) {
    (0, _classCallCheck3.default)(this, FormRest);

    this.$http = $http;
    this.sprintf = require("sprintf-js").sprintf;

    this.PATH = {
      FORMS_LIST: 'forms/',
      FORMS_PREVIEW: 'forms/render-preview/',
      FORMS_DETAIL: 'forms/%1$s/'
    };
  }

  (0, _createClass3.default)(FormRest, [{
    key: 'create',
    value: function create(postData) {
      return this.$http.post(this.PATH.FORMS_LIST, postData);
    }
  }, {
    key: 'update',
    value: function update(id, postData) {
      return this.$http.patch(this.sprintf(this.PATH.FORMS_DETAIL, id), postData);
    }
  }, {
    key: 'save',
    value: function save(postData) {
      return postData.id ? this.update(postData.id, postData) : this.create(postData);
    }
  }, {
    key: 'getList',
    value: function getList(params) {
      return this.$http.get(this.PATH.FORMS_LIST, { params: params });
    }
  }, {
    key: 'renderPreview',
    value: function renderPreview(postData) {
      return this.$http.post(this.PATH.FORMS_PREVIEW, postData);
    }
  }, {
    key: 'read',
    value: function read(id) {
      return this.$http.get(this.sprintf(this.PATH.FORMS_DETAIL, id));
    }
  }, {
    key: 'delete',
    value: function _delete(id) {
      return this.$http.delete(this.sprintf(this.PATH.FORMS_DETAIL, id));
    }
  }]);
  return FormRest;
}();

exports.default = FormRest;


//////////////////
// WEBPACK FOOTER
// ./src/api/FormResource.js
// module id = 319
// module chunks = 0